(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportItemDeleteController',PatchReportItemDeleteController);

    PatchReportItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatchReportItem'];

    function PatchReportItemDeleteController($uibModalInstance, entity, PatchReportItem) {
        var vm = this;
        vm.patchReportItem = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PatchReportItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
